import React from "react";

import ResourceIcon from "app/components/ResourceIcon";
import styles from "./styles.module.scss";

type PropsDef = {
  title: string;
  section: string;
};

/**
 * The header of a bay column (Figma 166:67254): the resource icon tile, the
 * bay title, and the section under it (decision Q17). Every bay gets the
 * same icon (decision Q7).
 */
export default function ResourceLabel({ title, section }: PropsDef) {
  return (
    <div className={styles.resource_label} data-testid="bay-column-header">
      <div className={styles.resource_icon_tile}>
        <ResourceIcon size={20} />
      </div>
      <div className={styles.resource_title}>{title}</div>
      {section && <div className={styles.resource_section}>{section}</div>}
    </div>
  );
}
